import { Dimensions, Platform, StatusBar } from "react-native";
import mq from "utils/mediaQuery";

const { width: screenW, height: screenH } = Dimensions.get("window");
const deviceWidth = { sm: 480, md: 640, lg: 767, xl: 960 };

const sizes = {
  deviceWidth,
  containerMaxWith: 576,
  statusBarHeight: Platform.OS === "web" ? 0 : StatusBar.currentHeight,
  isMediumScreen: screenW > deviceWidth.md,
  isLargeScreen: screenW > deviceWidth.lg,
  minWidth: (width: number) => screenW >= width,
  maxWidth: (width: number) => screenW <= width,
  screenW,
  screenH,
  tapOpacity: 0.7,
  radius: { sm: 5, md: 10, lg: 15, xl: 20, xxl: 25, xxxl: 30 },

  defaultIcon: 20,

  space: 12,

  inputsSpace: mq(30),

  drawerW: 230,

  tabScreensW: screenW * 0.9,

  gradientStart: { x: 0, y: 0 },
  gradientEnd: { x: 0.5, y: 1 },

  tagHeight: 25,

  inputsBetweenSpace: 20,

  iconTextSpace: 2,
};

export default sizes;
